<template>
  <div>
    <div class="page-title"><span v-html="AccountSvg" />Account</div>

    <div class="account-wrapper">
      <DeployerAccountSidebar />

      <div class="account-section">
        <NuxtPage />
      </div>
    </div>
  </div>
</template>

<script setup>
import AccountSvg from '~/assets/icons/account.svg?raw'
const deployerStore = useDeployerStore()
const whitelabelStore = useWhitelabelStore()
const accountStore = useAccountStore()

onMounted(() => {
  if (whitelabelStore.config?.paid_plans) {
    deployerStore.setPlans(
      whitelabelStore.config?.paid_plans.map((plan) => ({
        id: plan.id,
        name: plan.title,
        price: plan.price_per_month,
        extra: plan.price_per_extra_feed,
        titleBoxColor: plan.title_box_color,
        titleTextColor: plan.title_text_color,
        features: plan.features,
        paymentUrl: plan.payment_url,
        selected: false
      }))
    )
  }

  if (accountStore.account?.plan?.plan_id)
    deployerStore.selectPlan(accountStore.account?.plan?.plan_id)
})

watch(
  () => whitelabelStore.config?.paid_plans,
  () => {
    if (whitelabelStore.config?.paid_plans) {
      deployerStore.setPlans(
        whitelabelStore.config?.paid_plans.map((plan) => ({
          id: plan.id,
          name: plan.title,
          price: plan.price_per_month,
          extra: plan.price_per_extra_feed,
          titleBoxColor: plan.title_box_color,
          titleTextColor: plan.title_text_color,
          features: plan.features,
          paymentUrl: plan.payment_url,
          selected: false
        }))
      )
    }

    if (accountStore.account?.plan?.plan_id)
      deployerStore.selectPlan(accountStore.account?.plan?.plan_id)
  }
)

watch(
  () => accountStore.account,
  () => {
    if (accountStore.account?.plan?.plan_id)
      deployerStore.selectPlan(accountStore.account.plan.plan_id)
  }
)
</script>

<style lang="scss" scoped>
.account-wrapper {
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  gap: 50px;

  @media (max-width: 1023px) {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
  }

  :deep(.account-boxes) {
    display: flex;
    gap: 30px;
    flex-direction: column;
  }

  :deep(.account-subtitle) {
    font-size: 1.5rem;
    font-weight: 500;
    opacity: 0.6;
  }

  :deep(.account-subtext) {
    font-size: 1.3rem;
    opacity: 0.8;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  :deep(.account-line) {
    border: 0;
    border-top: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
    margin-block: 40px;
  }
}

.account-section {
  flex: 1 1 0;
}
</style>
